import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import BlockUi from "react-block-ui";
import { Loader } from "react-loaders";
import {
  SortableTreeWithoutDndContext as SortableTree,
  toggleExpandedForAll,
  getTreeFromFlatData,
} from "react-sortable-tree";
import RSC from "react-scrollbars-custom";

import Immutable from "seamless-immutable";
import isEqual from "lodash.isequal";

import {
  DragDropType,
  MenuType,
  LoaderType,
  INFINITY,
} from "../../helpers/enums";
import { MenuActionCreators } from "../../actions/menu";
import { SearchActionCreators } from "../../actions/search";

import SearchTarget from "../DragAndDropTargets/SearchTarget";
import CategoryTarget from "../DragAndDropTargets/CategoryTarget";
import CategorySource from "../DragAndDropSources/CategorySource";

import { combineArrays } from "@components/utils";

import { CONSTANTS } from "@constants";
const { CONFIRM, CANCEL } = CONSTANTS;

class LinkCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      treeData: Immutable(
        getTreeFromFlatData({
          flatData: props.treeData,
          getKey: ({ elementId }) => elementId,
          getParentKey: ({ parentElementId }) => parentElementId,
          rootKey: null,
        }),
        { deep: true }
      ),
      type: props.menuType,
      expanded: false,
      categories: props.categories,
    };
  }

  componentDidMount() {
    const { type } = this.state;
    const { getMenu } = this.props;
    getMenu(type, false, true);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.treeData, this.props.treeData)) {
      const newTreeData = this.state.expanded
        ? toggleExpandedForAll({
            treeData: this.props.treeData,
            expanded: this.state.expanded,
          })
        : this.props.treeData;
      this.setState({
        treeData: Immutable(
          getTreeFromFlatData({
            flatData: newTreeData,
            getKey: ({ elementId }) => elementId,
            getParentKey: ({ parentElementId }) => parentElementId,
            rootKey: null,
          }),
          { deep: true }
        ),
      });
    }
    if (!isEqual(prevProps.isOpen, this.props.isOpen) && this.props.isOpen) {
      const { type } = this.state;
      const { getMenu } = this.props;
      getMenu(type, false, true);
    }
    if (!isEqual(prevProps.menuType, this.props.menuType)) {
      this.setState({ type: this.props.menuType });
    }
    if (!isEqual(prevProps.categories, this.props.categories)) {
      this.setState({ categories: this.props.categories });
    }
  }

  updateTreeData = (treeData) =>
    this.setState({
      treeData: treeData,
    });

  searchCategories = (title, articles) => {
    const { type } = this.state;
    const { searchCategories } = this.props;

    if (searchCategories && typeof searchCategories === "function") {
      searchCategories(type, title, articles);
      if (title) {
        this.setState({ expanded: true });
      } else {
        this.setState({ expanded: false });
      }
    }
  };

  onAddItems = (categories) =>
    this.setState({
      categories: combineArrays(
        categories,
        this.state.categories,
        "categories"
      ),
    });

  onDeleteItems = (categories) =>
    this.setState({ categories: [...categories] });

  onChangeMenuType = (menuType) => {
    this.setState({ type: menuType });
    const { getMenu } = this.props;

    getMenu(menuType, false, true);
  };

  onCancel = (event) => {
    const { onToggle } = this.props;

    if (onToggle && typeof onToggle === "function") {
      this.setState({ expanded: false });
      onToggle(event);
    }
  };

  onSave = (event) => {
    const { onToggle, onSave } = this.props;
    const { categories } = this.state;

    if (onSave && typeof onSave === "function") {
      onSave(categories);
    }

    if (onToggle && typeof onToggle === "function") {
      this.setState({ expanded: false });
      onToggle(event);
    }
  };

  render() {
    const { isOpen, menuCardBlocking, maxLinks = INFINITY } = this.props;
    const { treeData, type, categories } = this.state;
    const { onAddItems: onChangeItems, onDeleteItems } = this;

    return (
      <Modal isOpen={isOpen} backdrop size="xl">
        <ModalHeader>
          <div className="d-flex justify-content-between">
            <div>Wybierz kategorie</div>
            <div>
              <Button
                className="btn-icon mr-2"
                color="alternate"
                type="button"
                onClick={this.onSave}
              >
                <i className="pe-7s-check btn-icon-wrapper" />
                {CONFIRM}
              </Button>
              <Button
                className="btn-icon mr-2"
                color="secondary"
                type="button"
                onClick={this.onCancel}
              >
                <i className="pe-7s-back btn-icon-wrapper" />
                {CANCEL}
              </Button>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={8}>
              <Card className="mb-2">
                <CardHeader>
                  <div className="widget-content p-0 d-flex flex1-1-0">
                    <div className="widget-content-wrapper">
                      <div className="widget-content-left flex0-0-3">
                        Wyszukaj kategorię
                      </div>
                      <div className="widget-content-right ml-3 d-flex flex1-1-0">
                        <Button
                          className="btn-icon border-0 mr-2 fsize-2"
                          active={type === MenuType.Horizontal}
                          type="button"
                          outline={type !== MenuType.Horizontal ? true : false}
                          color={
                            type === MenuType.Horizontal ? "link" : "light"
                          }
                          title="Wyszukaj z menu poziomego"
                          onClick={this.onChangeMenuType.bind(
                            this,
                            MenuType.Horizontal
                          )}
                        >
                          <i className="pe-7s-menu" />
                        </Button>
                        <Button
                          className="btn-icon border-0 mr-2 fsize-2 rotate-90"
                          active={type === MenuType.Vertical}
                          type="button"
                          outline={type !== MenuType.Vertical ? true : false}
                          color={type === MenuType.Vertical ? "link" : "light"}
                          title="Wyszukaj z menu pionowego"
                          onClick={this.onChangeMenuType.bind(
                            this,
                            MenuType.Vertical
                          )}
                        >
                          <i className="pe-7s-menu" />
                        </Button>
                        <SearchTarget
                          dropType={DragDropType.Article}
                          onChange={this.searchCategories}
                        />
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <BlockUi
                    tag="div"
                    blocking={menuCardBlocking}
                    loader={<Loader active type={LoaderType} />}
                  >
                    <div className="vh-100" style={{ overflow: "auto" }}>
                      <RSC>
                        <SortableTree
                          treeData={treeData}
                          onChange={this.updateTreeData}
                          rowHeight={80}
                          isVirtualized={false}
                          dndType={DragDropType.Category}
                          shouldCopyOnOutsideDrop={true}
                          canDrop={() => false}
                          generateNodeProps={({ node, path }) => {
                            return {
                              addItem: this.onAddItems,
                              items: categories,
                              max: maxLinks,
                              displayText: (
                                <FormGroup className="mb-0">
                                  <Input
                                    className="border-0 fsize-0-8"
                                    style={{ backgroundColor: "#fff" }}
                                    value={node.displayText}
                                    title={node.title}
                                    disabled={true}
                                  />
                                </FormGroup>
                              ),
                            };
                          }}
                          nodeContentRenderer={CategorySource}
                        />
                      </RSC>
                    </div>
                  </BlockUi>
                </CardBody>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="mb-2">
                <CardHeader>
                  <div className="widget-content p-0 d-flex flex1-1-0">
                    <div className="widget-content-wrapper">
                      <div className="widget-content-left">
                        Wybrane kategorie
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <CategoryTarget
                    items={categories.map((category) => ({...category, menuElementIsHidden: false}))}
                    dropType={
                      maxLinks !== INFINITY && categories.length >= maxLinks
                        ? DragDropType.Unknown
                        : DragDropType.Category
                    }
                    {...{ onChangeItems, onDeleteItems }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  }
}
const mapStateToProps = (state) => ({
  treeData: state.menu.menu || [],
  menuCardBlocking: state.uiBlockState.menuCardBlocking || false,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...MenuActionCreators, ...SearchActionCreators },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(LinkCategory);
